import { render, staticRenderFns } from "./ConnectAnchorage.vue?vue&type=template&id=a73c90b8&"
import script from "./ConnectAnchorage.vue?vue&type=script&lang=js&"
export * from "./ConnectAnchorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports